import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Select } from '@rmwc/select';
import Scrollbar from "react-scrollbars-custom";
import { connect } from "react-redux";
import LeftDoorWindow from './LeftDoorWindow/LeftDoorWindow';
import CenterDoorWindow from './CenterDoorWindow/CenterDoorWindow';
import RightDoorWindow from './RightDoorWindow/RightDoorWindow';
import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import { Accordion, Card, Button, Tabs, Tab, Nav } from 'react-bootstrap';
import * as actionCreator from "../../../action/index.js";
import * as cuComponent from '../../../redux/reducers/building_component/componentReducer.js';
import CurrencyFormat from 'react-currency-format';
import { const_var, params } from '../../../redux/reducers/reducer';
import { controls } from '../../../redux/reducers/common/eventReducer.js';
import ReadMore  from '../../ReadMore'
import DwDropDown from '../../Dropdown/DwDropDown.js';
import {  getBuildingName, hasGableLeanto, replaceLeanWithBuilding } from '../../../redux/reducers/utils.js';
import { makeTranslucent } from '../../../helpers/building/building_config/componentConfig.js';
import { findActiveWall } from '../../../helpers/building_pricing/wall_pricing/wallPricing.helper.js';
let checkCloseWall = false;
let checkWallValue = '';

let wallSelectionOption = (params) => {
  const centerOptions = [
      // {
      //   label: "Select",
      //   value: "select"
      // },
      {
          label: "Left",
          value: "c_b_l_w",
      },
      {
          label: "Right",
          value: "c_b_r_w",
      },
      {
          label: "Front",
          value: "c_b_f_w",
      },
      {
          label: "Back",
          value: "c_b_b_w",
      },
  ];

  const breezewayOptions = [
    // {
    //   label: "Select",
    //   value: "select"
    // },
    {
      label: "Front Storage Front Wall ",
      value: "c_b_f_w",
    },
    {
      label: "Front Storage Left Wall",
      value: "c_b_f_s_l_w",
    },
    {
      label: "Front Storage Right Wall",
      value: "c_b_f_s_r_w",
    },
    {
      label: "Front Storage Back Wall",
      value: "c_b_f_s_b_w",
    },
  ]

  let opt = !params.isBreezeway ? centerOptions : breezewayOptions;

    // Center Building End Storage Wall
    if (params.p_u_c) {
        if (params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t)) {
            opt.push({
                label: "Back Storage Front Wall",
                value: "c_b_f_s_w",
            })
        }
        if (params.endStoragePositionZ !== 0) {
            opt.push({
                label: "Back Storage Back Wall",
                value: "c_b_b_s_w",
            })
        }
        if (params.p_l_w !== 'Close') {
            opt.push({
                label: "Back Storage Left Wall",
                value: "c_b_l_s_w",
            })
        }
        if (params.p_r_w !== 'Close') {
            opt.push({
                label: "Back Storage Right Wall",
                value: "c_b_r_s_w",
            })
        }

        if (params.isBreezeway) {
            opt.push({
                label: "Back Storage Back Wall",
                value: "c_b_b_w",
            });
        }

        if (params.p_l_w === 'Close' && params.activeWall === "c_b_l_s_w") params.activeWall = "c_b_l_w"
        if (params.p_r_w === 'Close' && params.activeWall === "c_b_r_s_w") params.activeWall = "c_b_r_w"
    }

    // Center Building Left Storage Wall
    if (params.cB_addStorage_check_left) {
        if (params.p_f_w !== "Close") {
            opt.push({
                label: "Left Storage Front Wall",
                value: "c_b_l_s_f_w",
            })
        }
        if ( params.p_b_w !== "Close") {
            opt.push({
                label: "Left Storage Back Wall",
                value: "c_b_l_s_b_w",
            })
        }
        opt.push({
            label: "Left Storage Right Wall",
            value: "c_b_l_s_r_w",
        })
    }

    // Center Building Right Storage Wall
    if (params.cB_addStorage_check_right) {
        if (params.p_f_w !== "Close") {
            opt.push({
                label: "Right Storage Front Wall",
                value: "c_b_r_s_f_w",
            })
        }
        if ( params.p_b_w !== "Close") {
            opt.push({
                label: "Right Storage Back Wall",
                value: "c_b_r_s_b_w",
            })
        }
        opt.push({
            label: "Right Storage Right Wall",
            value: "c_b_r_s_l_w",
        })
    }

    const shouldShowWallsOptions = (leanType) => {
      if (!const_var.isLTBuilding) {
        return true;
      } 

      if(const_var.isLTBuilding) {
        if(const_var.selectedLeanType !== "") // user is on gable lean, want to see only selected gable's walls
        {
          if(hasGableLeanto(leanType) && const_var.selectedLeanType === leanType) {
            return true;
          }
          return false
        }
        else {
        // user is on center building, but want to see standard lean walls
          if(hasGableLeanto(leanType) ){
            return false
          }
          return true
        }
      }
      return false;
    };

    // Left Lean Walls
    if (params.add_left_lean && params.isShowCenter === false && shouldShowWallsOptions('left')) {
        // main walls
        opt.push(
            {
                label: "Left Lean Front Wall",
                value: params.leanStyle?.left === "gable" ? "G_L_L_F_W" : "L_L_F_W",
            },
            
            {
                label: params.leanStyle?.left === "gable" ? "Left Lean Left Wall" : "Left Lean Side Wall",
                value: params.leanStyle?.left === "gable" ? "G_L_L_L_W" : "L_L_L_W",
            },
        );
        if (params.leanStyle?.left === "gable") {
            opt.push({
                label: "Left Lean Right Wall",
                value: "G_L_L_R_W",
            });
        }
        // if (params.leanStyle?.left === "standard" || params.lean_p_h === params.p_h) {
        if (params.leanStyle?.left === "standard" || (params.leanStyle?.left === "gable" && params.p_l_w !== "Close")) {
          opt.push({
            label: "Left Lean Back Wall",
            value: params.leanStyle?.left === "gable" ? "G_L_L_B_W" : "L_L_B_W",
          });
        }

        // storage walls
        if (params.add_storage_check) {
            if (params.leftLeanStoragePosition !== params.lean_p_d - parseInt(params.add_storage)) {
                opt.push({
                    label: "Left Lean Storage Front Wall",
                    value: params.leanStyle?.left === "gable" ? "G_L_L_F_S_W": "L_L_F_S_W",
                });
            }
            if (params.leftLeanStoragePosition !== 0) {
                opt.push({
                    label: "Left Lean Storage Back Wall",
                    value: params.leanStyle?.left === "gable" ? "G_L_L_B_S_W": "L_L_B_S_W",
                });
            }
            if (params.p_b_c_b_l !== 'Close') {
                opt.push({
                    label: "Left Lean Storage Left Wall",
                    value: params.leanStyle?.left === "gable" ? "G_L_L_L_S_W" : "L_L_L_S_W",
                })
            }
            if (params.p_b_c_b_l_r !== 'Close') {     // *** the `p_b_c_b_l` need to change with new right wall close state variable
                if (params.leanStyle?.left === "gable") {
                    opt.push({
                        label: "Left Lean Storage Right Wall",
                        value: "G_L_L_R_S_W"
                    });
                }
                else {
                    opt.push({
                        label: "Left Lean Storage Right Wall",
                        value: "L_L_R_S_W"
                    });
                }
            } 

            // change the active wall name depending on the side wall close state
            if (params.leanStyle?.left === "gable") {
                if (params.p_b_c_b_l === 'Close' && params.activeWall === "G_L_L_L_S_W") params.activeWall = "G_L_L_L_W";   // left
                if (params.p_b_c_b_l_r === 'Close' && params.activeWall === "G_L_L_R_S_W") params.activeWall = "G_L_L_R_W";   // right *** the `p_b_c_b_l` need to change with new right wall close state variable
            } else {
                if (params.p_b_c_b_l === 'Close' && params.activeWall === "L_L_L_S_W") params.activeWall = "L_L_L_W";
            }
        }
    }

    // Right Lean Walls
    if (params.add_right_lean && params.isShowCenter === false && shouldShowWallsOptions('right')) {
        // main walls
        opt.push(
            {
                label: "Right Lean Front Wall",
                value: params.leanStyle?.right === "gable" ?  "G_R_L_F_W" : "R_L_F_W",
            },
            
        );
        if (params.leanStyle?.right === "gable") {
            opt.push({
                label: "Right Lean Left Wall",
                value: "G_R_L_L_W"
            });
        }
        opt.push({
            label: params.leanStyle?.right === "gable" ? "Right Lean Right Wall" : "Right Lean Side Wall",
            value: params.leanStyle?.right === "gable" ?  "G_R_L_R_W" : "R_L_R_W" ,
        });
        // if (params.leanStyle?.right === "standard" || params.leanR_p_h === params.p_h) {
        if (params.leanStyle?.right === "standard" || (params.leanStyle?.right === "gable" && params.p_r_w !== 'Close')) {
          opt.push({
            label: "Right Lean Back Wall",
            value: params.leanStyle?.right === "gable" ?  "G_R_L_B_W" : "R_L_B_W",
          });
        }

        // storage walls
        if (params.add_storage_check_right) {
            if (params.rightLeanStoragePosition !== params.leanR_p_d - parseInt(params.add_storage_right)) {
                opt.push({
                    label: "Right Lean Storage Front Wall",
                    value: params.leanStyle?.right === "gable" ? "G_R_L_F_S_W": "R_L_F_S_W",
                })
            }
            if (params.rightLeanStoragePosition !== 0) {
                opt.push({
                    label: "Right Lean Storage Back Wall",
                    value: params.leanStyle?.right === "gable" ? "G_R_L_B_S_W": "R_L_B_S_W",
                })
            }
            if (params.p_b_c_b_r !== 'Close') {              
              if (params.leanStyle?.right === "gable"){
                opt.push({
                    label: "Right Lean Storage Left Wall",
                    value: "G_R_L_L_S_W",
                });
              }
              else {
                opt.push({
                    label: "Right Lean Storage Right Wall",
                    value: "R_L_R_S_W",
                });
               }
            }
            if (params.p_b_c_b_r_r !== 'Close') {
                if (params.leanStyle?.right === "gable") {
                    opt.push({
                        label: "Right Lean Storage Right Wall",
                        value: "G_R_L_R_S_W"
                    });
                }
                else {
                    opt.push({
                        label: "Right Lean Storage Left Wall",
                        value: "R_L_L_S_W"
                    });
                }
            }

            // change the active wall name depending on the side wall close state
            if (params.leanStyle?.right === "gable") {
                if (params.p_b_c_b_r === 'Close' && params.activeWall === "G_R_L_L_S_W") params.activeWall = "G_R_L_L_W";   // left *** the `p_b_c_b_r` need to change with new right wall close state variable
                if (params.p_b_c_b_r === 'Close' && params.activeWall === "G_R_L_R_S_W") params.activeWall = "G_R_L_R_W";   // right
            } else {
                if (params.p_b_c_b_r === 'Close' && params.activeWall === "L_L_L_S_W") params.activeWall = "L_L_L_W";
            }
        }
  
    }

    // Front Lean Walls
    if (params.add_front_lean && params.isShowCenter === false && shouldShowWallsOptions('front')) {
        // main walls
        opt.push(
            {
                label: "Front Lean Front Wall",
                value: params.leanStyle?.front === "gable" ? "G_F_L_F_W" : "F_L_R_W",
            },
        );
        opt.push({
            label: params.leanStyle?.front === "gable" ? "Front Lean Left Wall" : "Front Lean Side Wall",
            value: params.leanStyle?.front === "gable" ? "G_F_L_L_W" : "F_L_F_W",
        });
        if (params.leanStyle?.front === "gable") {
            opt.push({
                label: "Front Lean Right Wall",
                value: "G_F_L_R_W"
            });
        };
        // if (params.leanStyle?.front === "standard" || params.leanF_p_h === params.p_h && params.leanF_p_w === params.p_w && params.p_r_p == params.b_l_t_r_pF) {
        if (params.leanStyle?.front === "standard" || (params.leanStyle?.front === "gable" && params.p_f_w !== 'Close')) {
          opt.push({
            label: "Front Lean Back Wall",
            value: params.leanStyle?.front === "gable" ? "G_F_L_B_W" : "F_L_L_W",
          })
        };

        // storage walls
        if (params.add_storage_check_front) {
            if (params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) {
                opt.push({
                    label: "Front Lean Storage Front Wall",
                    value: params.leanStyle?.front === "gable" ? "G_F_L_F_S_W" : "F_L_R_S_W",
                })
            }
            if (params.frontLeanStoragePosition !== 0) {
                opt.push({
                    label: "Front Lean Storage Back Wall",
                    value: params.leanStyle?.front === "gable" ? "G_F_L_B_S_W" : "F_L_L_S_W",
                })
            }
            if (params.p_b_c_b_f_l !== 'Close') {
                opt.push({
                    label: params.leanStyle?.front === "gable" ? "Front Lean Storage Left Wall" : "Front Lean Storage Side Wall",
                    value: params.leanStyle?.front === "gable" ? "G_F_L_L_S_W" : "F_L_F_S_W"
                });
            }
            if (params.p_b_c_b_f_l !== 'Close') {             // *** the `p_b_c_b_f_l` need to change with new right wall close state variable
                if (params.leanStyle?.front === "gable") {
                    opt.push({
                        label: "Front Lean Storage Right Wall",
                        value: "G_F_L_R_S_W"
                    });
                }
                // else {
                //     opt.push({
                //         label: "Front Lean Storage Right Wall",
                //         value: "F_L_B_S_W"
                //     });
                // }
            }
            
            // change the active wall name depending on the side wall close state
            if (params.leanStyle?.front === "gable") {
                if (params.p_b_c_b_f_l === 'Close' && params.activeWall === "G_F_L_L_S_W") params.activeWall = "G_F_L_L_W";   // left
                if (params.p_b_c_b_f_l === 'Close' && params.activeWall === "G_F_L_R_S_W") params.activeWall = "G_F_L_R_W";   // right *** the `p_b_c_b_f_l` need to change with new right wall close state variable
            } else {
                if (params.p_b_c_b_f_l === 'Close' && params.activeWall === "F_L_F_S_W") params.activeWall = "F_L_F_W" 
            }
        }

    }

    // Back Lean Walls
    if (params.add_back_lean && params.isShowCenter === false && shouldShowWallsOptions('back')) {
        // main walls
        opt.push(
            {
                label: "Back Lean Front Wall",
                value: params.leanStyle?.back === "gable" ? "G_B_L_F_W" : "B_L_F_W",
            },
        );
        // if (params.leanStyle?.back === "standard" || params.leanB_p_h === params.p_h && params.leanB_p_w === params.p_w && params.p_r_p == params.b_l_t_r_pB) {
        if (params.leanStyle?.back === "standard" || (params.leanStyle?.back === "gable" && params.p_b_w !== 'Close')) {
          opt.push({
            label: "Back Lean Back Wall",
            value: params.leanStyle?.back === "gable" ? "G_B_L_B_W" : "B_L_B_W",
          })
        };
        if (params.leanStyle?.back === "gable") {
            opt.push({
                label: "Back Lean Left Wall",
                value: "G_B_L_L_W"
            });
        };
        opt.push({
            label: params.leanStyle?.back === "gable" ? "Back Lean Right Wall" : "Back Lean Side Wall",
            value: params.leanStyle?.back === "gable" ? "G_B_L_R_W" : "B_L_S_W",
        })

        // storage walls
        if (params.add_storage_check_back) {
            if (params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) {
                opt.push({
                    label: "Back Lean Storage Front Wall",
                    value: params.leanStyle?.back === "gable" ? "G_B_L_F_S_W" : "B_L_L_S_W",
                })
            }
            if (params.backLeanStoragePosition !== 0) {
                opt.push({
                    label: "Back Lean Storage Back Wall",
                    value: params.leanStyle?.back === "gable" ? "G_B_L_B_S_W" : "B_L_R_S_W",
                })
            }
            if (params.p_b_c_b_b_l !== 'Close') {             // *** the `p_b_c_b_b_l` need to change with new right wall close state variable
                if (params.leanStyle?.back === "gable") {
                    opt.push({
                        label: "Back Lean Storage Left Wall",
                        value: "G_B_L_L_S_W"
                    });
                }
                // else {
                //     opt.push({
                //         label: "Back Lean Storage Left Wall",
                //         value: "B_L_B_S_W"
                //     });
                // }
            }
            if (params.p_b_c_b_b_l !== 'Close') {
                opt.push({
                    label: params.leanStyle?.back === "gable" ? "Back Lean Storage Right Wall" : "Back Lean Storage Side Wall",
                    value: params.leanStyle?.back === "gable" ? "G_B_L_R_S_W" : "B_L_F_S_W"
                });
            }
            
            // change the active wall name depending on the side wall close state
            if (params.leanStyle?.back === "gable") {
                if (params.p_b_c_b_b_l === 'Close' && params.activeWall === "G_B_L_L_S_W") params.activeWall = "G_B_L_L_W";   // left *** the `p_b_c_b_b_l` need to change with new right wall close state variable
                if (params.p_b_c_b_b_l === 'Close' && params.activeWall === "G_B_L_R_S_W") params.activeWall = "G_B_L_R_W";   // right
            } else {
                if (params.p_b_c_b_b_l === 'Close' && params.activeWall === "B_L_F_S_W") params.activeWall = "B_L_S_W" 
            }
        }

    }

  let selectVal = opt.findIndex((val)=>val.label == "Select")
  // console.log(cuComponent.wallnameBySec[params.activeWall],const_var.wallSelection.centerBuildingWall,"wallnameBySec");
  
  if(((cuComponent.wallnameBySec[params.activeWall] == "center") || (const_var.wallSelection.centerBuildingWall == "select" && cuComponent.wallnameBySec[params.activeWall].includes("lean"))) && selectVal != -1){
    opt.shift()
  }

  if(const_var.isLTBuilding && const_var.selectedLeanType !== "") {
    opt = opt.map(option => ({...option, label: replaceLeanWithBuilding( option?.label ?? "")}))
  }

  return opt;
}

class DoorWindow extends Component {

  constructor(props) {
    super(props);
    this.state = {
        doorSelect: "Roll-Up",
        currentActiveWall:"c_b_f_w"
        // wallSelect: "Please make sure to closed the wall",
        // wallSelect: "c_b_f_w",
    };
  }
  componentDidUpdate() {
    checkWallValue = this.props.const_var.checkWallClose[this.props.params.activeWall];
    checkCloseWall = this.props.const_var.scene && this.props.const_var.scene.getObjectByName(this.props.params.activeWall)!=undefined? this.props.const_var.scene.getObjectByName(this.props.params.activeWall).visible:true;
    if(checkWallValue == 'utility')
    {
      checkCloseWall = true;
    }else{
      if(this.props.params[checkWallValue]!='Close')
      {
        checkCloseWall = false;
      }
    }
  }
  handleWallChange(value) {
    // console.log(value,cuComponent.wallnameBySec[this.props.params.activeWall],"checkWallValue",checkCloseWall)

    makeTranslucent(controls.isCheckActiveTab,value,params.is_translusant,const_var.scene);
    // this.setState({wallSelect: e.target.value});
    // console.log(e.target.value,"e.target.value",this.props.const_var.scene.getObjectByName(e.target.value))
      this.props.cameraFocusOnWall(value);
      checkCloseWall = (this.props.const_var.scene && this.props.const_var.scene.getObjectByName(value)!=undefined)?this.props.const_var.scene.getObjectByName(value).visible:true;
      checkWallValue = this.props.const_var.checkWallClose[this.props.params.activeWall];
      // console.log(checkWallValue,"checkWallValue",checkCloseWall)
      if(checkWallValue=='utility')
      {
      checkCloseWall = true;
    }else{
      if(this.props.params[checkWallValue]!='Close')
      {
        checkCloseWall = false;
      }
    }
    // this.props.const_var.controls.target.set(0, this.props.params.p_h / 2, 0);
    //this.props.cameraFocusOnWall(this.props, e.target.value);
    let dwIconsDiv = document.getElementById("doorwindowicons");
    dwIconsDiv && dwIconsDiv.classList.add("d-none");

    if(value != this.state.currentActiveWall){
      this.setState({
        currentActiveWall : value
      })
    }
  }

  handleMouseUp = (e) => {
    if (controls.isCheckActiveTab !== 'doorwindow' || (controls.isCheckActiveTab === 'doorwindow' && params.activeWall.substring(0, 4) === 'c_b_')) {
      let currentActiveWall = findActiveWall(e.target.localName,this.props.const_var.controls,this.props.const_var.wallSelection.centerBuildingWall,controls.isCheckActiveTab);
      if(currentActiveWall != this.state.currentActiveWall){
        this.setState({
          currentActiveWall : currentActiveWall
        })
      }
    }
  };


  componentWillUnmount(){
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleMouseUp);

  }
  
  // handleWallChange(e) {
  //   // this.setState({wallSelect: e.target.value});
  //   // console.log(e.target.value,"e.target.value",this.props.const_var.scene.getObjectByName(e.target.value))
  //   this.props.cameraFocusOnWall(e.target.value);
  //   checkCloseWall = (this.props.const_var.scene.getObjectByName(e.target.value) != undefined) ? this.props.const_var.scene.getObjectByName(e.target.value).visible : true;
  //   checkWallValue = this.props.const_var.checkWallClose[this.props.params.activeWall];
  //   if (checkWallValue == 'utility') {
  //     checkCloseWall = true;
  //   } else {
  //     if (this.props.params[checkWallValue] != 'Close') {
  //       checkCloseWall = false;
  //     }
  //   }
  //   // this.props.const_var.controls.target.set(0, this.props.params.p_h / 2, 0);
  //   //this.props.cameraFocusOnWall(this.props, e.target.value);
  //   let dwIconsDiv = document.getElementById("doorwindowicons");
  //   dwIconsDiv && dwIconsDiv.classList.add("d-none");
  // }

  shouldComponentUpdate() {
    checkWallValue = this.props.const_var.checkWallClose[this.props.params.activeWall];
      checkCloseWall = this.props.const_var.scene && this.props.const_var.scene.getObjectByName(this.props.params.activeWall)!=undefined?this.props.const_var.scene.getObjectByName(this.props.params.activeWall).visible:true;
      if(checkWallValue == 'utility')
      {
        checkCloseWall = true;
      }else{
        if(this.props.params[checkWallValue]!='Close')
        {
          checkCloseWall = false;
        }
      }
    return true;
  }

  renderDoorWindowWithSorting=(doorWindowData,newDoorsArray,type)=>{
    if(type == 'walkin'){
      // sorting is done according to this array
      let sortedWalkInArray = ["Standard Door","Diamond Window","9 Lite","Premium 6 Panel","Premium 9 Lite","Premium Solid"]
      let finalWalkInData = []
      doorWindowData.map((door)=>{
          let findIndex = sortedWalkInArray.findIndex(data => data == door.name)
          finalWalkInData.push({'key' : door.type,'name' : door.name, 'value': door.sizes, 'indexNo': findIndex != -1 ? findIndex : sortedWalkInArray.length})
      })  
      finalWalkInData.sort((a,b)=> a.indexNo - b.indexNo)    
      return finalWalkInData &&
        finalWalkInData.map((obj ,index) => {
          let doorType = ""
         
          if(obj.key == "4_lite") {
            doorType = "four_lite_walkin_door"
          } else if(obj.key == "5_lite_walkin") {
            doorType = "five_lite_walkin"
          } else if(obj.key == "5_lite_plan_door_walkin") {
            doorType = "five_lite_plan_door_walkin"
          } else if(obj.key == "5_lite_with_right_knob") {
            doorType = "five_lite_with_right_knob_walkin"
          } else if(obj.key == "6_lite_walkin") {
            doorType = "six_lite_walkin"
          } else if(obj.key == "9_lite_walkin" || obj.key == "9_lite_l_swing_walkin" || obj.key == "9_lite_panel_door_right_knob_walkin") {
            doorType = "nine_lite_walkin_door"
          } else if(obj.key == "11_lite_walkin") {
            doorType = "eleven_lite_walkin"
          } else if(obj.key == "9_lite_double_door_walkin") {
            doorType = "nine_lite_double_door_walkin"
          } else if(obj.key == "11_lite_double_door_walkin") {
            doorType = "eleven_lite_double_door_walkin"
          } else if(obj.key.includes("15_lite_double_door") || obj.key == "15_lite_door_with_center_right_knob_walkin") {
            doorType = "fifteen_lite_double_door_walkin"
          } else if(obj.key == "solid_l_swing_walkin") {
            doorType = "solid_walkin"
          } else if(obj.key == "9_lite_plain_door" || obj.key == "9_lite_plain_door_right_knob_walkin") {
            doorType = "nine_lite_plan_door_walkin"
          } else if(obj.key.includes("diamond")) {
            doorType = "diamond_window_walkin"
          } else if(obj.key == "black_plain_door_left_knob_walkin" || obj.key == "brown_plain_door_left_knob_walkin") {
            doorType = "home_door_with_right_knob_walkin"
          } else if(obj.key == "black_plain_door_right_knob_walkin" || obj.key == "brown_plain_door_right_knob_walkin") {
            doorType = "standard_walkin"
          } else {
            doorType = obj.key
          }
          
          return (
            <div className='door-item' onClick={(e) => {
              this.props.addDoorComponent(
                "walkin",
                obj?.key,
                this.props.params.activeWall,
                obj.value[0].fixed_sizes?.[0]?.width + "x" + obj.value[0].fixed_sizes?.[0]?.height,
                "Walk",
                obj?.key,
                obj?.name
              );
            }}>
              <div>
                <div className='door-item-icon'>
                  <span className={`icon-${doorType}`}>
                    {
                      newDoorsArray.filter(data => data.parent_array_key == "Walk" && data.nested_array_key == obj?.name) != undefined &&
                      newDoorsArray.filter(data => data.parent_array_key == "Walk" && data.nested_array_key == obj?.name).length > 0 &&
                      <div className='door-count-badge' >
                        {newDoorsArray.filter(data => data.parent_array_key == "Walk" && data.nested_array_key == obj?.name).length}
                      </div>
                    }
                  </span>
                </div>
                <div className='door-type'>{obj?.name}</div>
                <div className='door-item-overlay'>CLICK TO ADD</div>    
                <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span>                                       
              </div>
              {/* </div> */}
            </div>
          )

        })        
    }

    if(type == 'window'){
      // sorting is done according to this array
      let sortedWalkInArray =  ["Standard","Double Pane (No Grid)","Impact Windows (No Grid)","Double Pane (with Grid)"]
      let finalWalkInData = []
      doorWindowData.map((window)=>{
          let findIndex = sortedWalkInArray.findIndex(data => data == window.name)
          finalWalkInData.push({'key' : window.type,'name' : window.name, 'value': window.sizes, 'indexNo': findIndex != -1 ? findIndex : sortedWalkInArray.length})
      })  
      finalWalkInData.sort((a,b)=> a.indexNo - b.indexNo)    
      return finalWalkInData &&
        finalWalkInData.map((obj ,index) => {
            let windowType = ""
            if(obj.key == "window_with_shutters_window") {
              windowType =  "window_with_shutters_window"
            } else if(obj.key == "window_with_shutters_4_grid_window"){
              windowType =  "window_with_shutters_4-grid_window"
            } else if(obj.key == "window_with_shutters_6_grid_window") {
              windowType = "window_with_shutters_6-grid_window"
            } else if(obj.key == "6_grid_window_with_black_trim_window" || obj.key == "black_frame_with_standard_glass_window" || obj.key == "window_with_black_grid_window"){
              windowType = "black_frame_with_standard_glass_window"
            } else if(obj.key == "black_half_net_window"){
              windowType = "black_half_net_window"
            } else if(obj.key == "black_transom_5_grid_window") {
              windowType = "transom_window"
            } else if(obj.key.includes("transom_6_grid_window")) {
              windowType = "transom_6_grid_window"
            } else if(obj.key == "window_8_grid_window" || obj.key == "window_with_white_4_grid_window" || obj.key == "window_with_black_4_grid_window" || obj.key == "black_window"){
              windowType = "window_eight_grid_window"
            } else if(obj.key == "standard_window"){
              windowType =  "standard_window"
            } else if(obj.key.includes("window_without_shutters_window")) {
              windowType = "window_without_shutters_window"
            } else if(obj.key.includes("double_pane_single_glass_window")) {
              windowType = "double_pane_window"
            }else if(obj.key.includes("black_double_pane_single_glass_window")) {
              windowType = "double_pane_window"
            }else if(obj.key.includes("9_panel_(3x3_grid)_window")) {
              windowType = "9_panel_3x3_grid_window"
            }else if(obj.value[0]?.door_type.includes("4_grid_window_with_burnished_slate_trim_window")) {
              windowType = "bronze_window_with_4_grid_window"
            } else {
              windowType = obj.key
            }
            return (
              <div className='door-item' onClick={(e) => {
                this.props.addDoorComponent(
                  "window",
                  obj.key,
                  this.props.params.activeWall,
                  obj.value[0].fixed_sizes?.[0]?.width + "x" + obj.value[0].fixed_sizes?.[0]?.height,
                  "Windows",
                  obj.key,
                  obj.name
                );
              }}>
                  <div>
                  <div className='door-item-icon'>
                  <span className={`icon-${windowType} custom_name`}>
                      {
                        newDoorsArray.filter(data => data.parent_array_key == "Windows" && data.child_array_key == obj.key && data.nested_array_key == obj.name) != undefined &&
                        newDoorsArray.filter(data => data.parent_array_key == "Windows" && data.child_array_key == obj.key && data.nested_array_key == obj.name).length > 0 &&
                        <div className='door-count-badge' >
                          {newDoorsArray.filter(data => data.parent_array_key == "Windows" && data.child_array_key == obj.key && data.nested_array_key == obj.name).length}
                        </div>
                      }
                  </span>
                  </div>
                  <div className='door-type'>{obj.name}</div>
                  <div className='door-item-overlay'>CLICK TO ADD</div>
                  <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                </div>
              </div>
            )
        })  
    }
  }

  render() {
    const isSelectSteelBuildingMnf = const_var.crmSetting.api_token == "SIYjHGPtUSuZXJ29w8P0Em9fvnLsoXNDt8WTQJXFMNUlUJ4fUN1hhQRiKMQN0qMx" ? true : false;
    let DoorVar = this.props.params.doorType;

    if (this.props.const_var.custDM.w != undefined) { this.props.params.f_r_m_o_t = this.props.const_var.custDM.w; }
    if (this.props.const_var.custDM.h != undefined) { this.props.params.f_r_m_o_t1 = this.props.const_var.custDM.h; }
    if (this.props.params.f_r_m_o_t != "Select" && this.props.params.f_r_m_o_t1 != "Select") {
      DoorVar = "CustomFrameout";
    }

    let isFrameoutDisableWalls =
      (this.props.params.activeWall === 'c_b_f_w' && this.props.params.p_f_w !== "Close") ||
      (this.props.params.activeWall === 'c_b_b_w' && this.props.params.p_b_w !== "Close") ||
      ((this.props.params.activeWall === 'L_L_F_W' || this.props.params.activeWall === 'G_L_L_F_W') && this.props.params.p_b_c_b_l_f !== "Close") ||
      ((this.props.params.activeWall === 'L_L_B_W' || this.props.params.activeWall === 'G_L_L_B_W') && this.props.params.p_b_c_b_l_b !== "Close") ||
      ((this.props.params.activeWall === 'R_L_F_W' || this.props.params.activeWall === 'G_R_L_F_W') && this.props.params.p_b_c_b_r_f !== "Close") ||
      ((this.props.params.activeWall === 'R_L_B_W' || this.props.params.activeWall === 'G_R_L_B_W') && this.props.params.p_b_c_b_r_b !== "Close") ||
      ((this.props.params.activeWall === 'F_L_R_W' || this.props.params.activeWall === 'G_F_L_F_W') && this.props.params.p_b_c_b_f_f !== "Close") ||
      ((this.props.params.activeWall === 'F_L_L_W' || this.props.params.activeWall === 'G_F_L_B_W') && this.props.params.p_b_c_b_f_b !== "Close") ||
      ((this.props.params.activeWall === 'B_L_F_W' || this.props.params.activeWall === 'G_B_L_F_W') && this.props.params.p_b_c_b_b_f !== "Close") ||
      ((this.props.params.activeWall === 'B_L_B_W' || this.props.params.activeWall === 'G_B_L_B_W') && this.props.params.p_b_c_b_b_b !== "Close")
    ;

    let componentCountObj = {};
    let nestedComponentCountObj = { "Garage": {}, "Garage_Frameout": {}, "Walk": {}, "Walk_Frameout": {}, "Windows": {}, "Windows_Frameout": {} }

    this.props.const_var.entry_points.map((item) => {

      if (componentCountObj.hasOwnProperty(item.parent_array_key)) {
        componentCountObj[`${item.parent_array_key}`] += 1;
      } else {
        componentCountObj[`${item.parent_array_key}`] = 1
      }


      if (nestedComponentCountObj[`${item.parent_array_key}`].hasOwnProperty(item.nested_array_key)) {
        if (item.parent_array_key == "Garage") {
          nestedComponentCountObj["Garage"][`${item.nested_array_key}`] += 1;
        }
        if (item.parent_array_key == "Garage_Frameout") {
          nestedComponentCountObj["Garage_Frameout"][`${item.nested_array_key}`] += 1;
        }
        if (item.parent_array_key == "Walk") {
          nestedComponentCountObj["Walk"][`${item.nested_array_key}`] += 1;
        }
        if (item.parent_array_key == "Walk_Frameout") {
          nestedComponentCountObj["Walk_Frameout"][`${item.nested_array_key}`] += 1;
        }
        if (item.parent_array_key == "Windows") {
          nestedComponentCountObj["Windows"][`${item.nested_array_key}`] += 1;
        }
        if (item.parent_array_key == "Windows_Frameout") {
          nestedComponentCountObj["Windows_Frameout"][`${item.nested_array_key}`] += 1;
        }
      } else {
        if (item.parent_array_key == "Garage") {
          nestedComponentCountObj["Garage"][`${item.nested_array_key}`] = 1;
        }
        if (item.parent_array_key == "Garage_Frameout") {
          nestedComponentCountObj["Garage_Frameout"][`${item.nested_array_key}`] = 1;
        }
        if (item.parent_array_key == "Walk") {
          nestedComponentCountObj["Walk"][`${item.nested_array_key}`] = 1;
        }
        if (item.parent_array_key == "Walk_Frameout") {
          nestedComponentCountObj["Walk_Frameout"][`${item.nested_array_key}`] = 1;
        }
        if (item.parent_array_key == "Windows") {
          nestedComponentCountObj["Windows"][`${item.nested_array_key}`] = 1;
        }
        if (item.parent_array_key == "Windows_Frameout") {
          nestedComponentCountObj["Windows_Frameout"][`${item.nested_array_key}`] = 1;
        }

      }
    })
    let newDoorsArray = this.props.const_var.newDoorsArray
    
    if(const_var.isLTBuilding ) {
      if(const_var.selectedLeanType === "") {
        newDoorsArray = newDoorsArray.filter(door => {
          return !door.userData.wallName.includes("G_R") && !door.userData.wallName.includes("G_L") && !door.userData.wallName.includes("G_F") && !door.userData.wallName.includes("G_B")
        })
      }
      if(const_var.selectedLeanType === "right") {
        newDoorsArray = newDoorsArray.filter(door => {
          return door.userData.wallName.includes("G_R")
        })
      }
      if(const_var.selectedLeanType === "left") {
        newDoorsArray = newDoorsArray.filter(door => {
          return door.userData.wallName.includes("G_L")
        })
      }
      if(const_var.selectedLeanType === "front") {
        newDoorsArray = newDoorsArray.filter(door => {
          return door.userData.wallName.includes("G_F")
        })
      }
      if(const_var.selectedLeanType === "back") {
        newDoorsArray = newDoorsArray.filter(door => {
          return door.userData.wallName.includes("G_B")
        })
      }
    }
    function FrameoutsCount() {
      let totalCount = 0;

      let garageFrameoutCount = newDoorsArray.filter(data=>data.parent_array_key=="Garage_Frameout").length;
      let walkFrameoutCount = newDoorsArray.filter(data=>data.parent_array_key=="Walk_Frameout").length;
      let windowFrameoutCount = newDoorsArray.filter(data=>data.parent_array_key=="Windows_Frameout").length;

      totalCount = garageFrameoutCount + walkFrameoutCount + windowFrameoutCount;

      return totalCount;
    }

    let frameoutCount = FrameoutsCount()
    const leanWalls = wallSelectionOption(this.props.params).filter(item => (!item.value.includes("c_b") && !item.value.includes("F_S_L_R_W") )|| item.value.includes("select"))
    const cbWalls = wallSelectionOption(this.props.params).filter(item => ((item.value.includes(("c_b")) || item.value.includes("F_S_L_R_W")) && !item.value.includes(("F_L")) && !item.value.includes(("R_L")) && !item.value.includes(("B_L")) && !item.value.includes(("L_L"))) || (item.value.includes("select")) )
    
    return (
      <div className="building-elements-sec door-window-component no-price-component" >
        <div className="building-elements-sec-mid pt-0">
          <div className="building-elements-sec-mid-scroll">
            <form>
              <Tab.Container defaultActiveKey="centerBuilding" activeKey={(this.props.const_var.focusedSection == "center" || this.props.const_var.focusedSection == "")? "centerBuilding": "leanTos"} > 
                <div className='doors-windows-title'>Choose Wall To Place The Doors/Windows/Frame-Outs.</div>
                <Nav variant="tabs" className="nav-tab-strip doors-windows-tab">

                    {(this.props.isLTBuilding ? this.props.selectedLeanType === "" : true) && <div className='center-building-wall' style={{width: ((this.props.params.add_front_lean || this.props.params.add_back_lean || this.props.params.add_left_lean || this.props.params.add_right_lean) && wallSelectionOption(this.props.params).filter(item => !item.value.includes(("c_b"))).length > 0) ? '50%': '100%'}}>
                      <DwDropDown
                        options={cbWalls}
                        onChange={(value) => {
                          this.handleWallChange(value); 
                          this.props.wallSelection("center", value)
                        }}
                        value={cbWalls.find((e) => e.value == this.props.params.activeWall)?.value || this.props.const_var.wallSelection.centerBuildingWall}
                        label={'Center Building Wall'}
                      />
                  </div>}
                  {
                    (!this.props.isLTBuilding || (this.props.isLTBuilding && this.props.selectedLeanType === "")) ?
                    <>
                    {/* standard leans */}
                    {wallSelectionOption(this.props.params).filter(item => !item.value.includes(("c_b"))).length > 0 && (this.props.params.add_front_lean || this.props.params.add_back_lean || this.props.params.add_left_lean || this.props.params.add_right_lean ) &&
                      <div className='lean-to-wall' style={{width: '50%'}}>
                          {wallSelectionOption(this.props.params).filter(item => !item.value.includes(("c_b"))).length > 0 &&
                            <DwDropDown
                                options={leanWalls}
                                onChange={(value) => {
                                  this.handleWallChange(value);
                                  this.props.wallSelection("lean", value)
                                }}
                                label={'Lean To’s Wall'}
                                value={leanWalls.find((e) => e.value == this.props.params.activeWall)?.value || this.props.const_var.wallSelection.leanToWall} 

                              />
                          }
                      </div>
                    }
                    </>
                    : 
                    <>
                    {/* gable leans */}
                    {wallSelectionOption(this.props.params).filter(item => !item.value.includes(("c_b"))).length > 0 && (this.props.params.add_front_lean || this.props.params.add_back_lean || this.props.params.add_left_lean || this.props.params.add_right_lean ) &&
                      <div className='lean-to-wall' style={{width: "100%"}}>
                          {wallSelectionOption(this.props.params).filter(item => !item.value.includes(("c_b"))).length > 0 &&
                            <DwDropDown
                                options={leanWalls}
                                onChange={(value) => {
                                  this.handleWallChange(value);
                                  this.props.wallSelection("lean", value)
                                }}
                                label={`${getBuildingName(this.props.selectedLeanType)} Wall`}
                                value={wallSelectionOption(this.props.params).filter(item => !item.value.includes(("c_b"))).find((e) => e.value == this.props.params.activeWall)?.value || this.props.const_var.wallSelection.leanToWall} 
                              />
                          }
                      </div>
                    }
                    </>
                    
                  }
                  
                </Nav>

              </Tab.Container>
              
              <div className='card-body-inner'>
                <div className="price-row mt-3 mb-3">
                  <aside className="price-row-left d-block">
                    <div className='col-12 p-0'>
                      <div className="">
                        <Accordion className="w-full accordion-type-2" defaultActiveKey="garagedoor">
                          <Card className='active'>
                            <Card.Header>

                              <Accordion.Toggle as={Button} variant="link" eventKey="garagedoor" onClick={(e) => this.props.handleAccordion(e)}>
                                <div className='d-flex align-items-center relative-container' >
                                  <span className='icon-roll-up-garage-door dw-icons'></span>
                                  <span className='text '>{!isSelectSteelBuildingMnf ? (this.props.params.m_s_n == 127 ? "Garage Doors" : "Doors") : "Roll Up Doors"}</span>
                                  <div>
                                    {
                                      newDoorsArray.filter(data=>data.parent_array_key=="Garage") != undefined && 
                                      newDoorsArray.filter(data=>data.parent_array_key=="Garage").length > 0 && 
                                      <div className='door-total-count-badge'>
                                        {newDoorsArray.filter(data=>data.parent_array_key=="Garage").length}
                                      </div>
                                    }
                                  </div>
                                </div>

                                <div className=''>
                                  <span className='icon icon-plus'></span>
                                </div>


                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="garagedoor">
                              <Card.Body className={(this.props.params.m_s_n == 148 || this.props.params.m_s_n == 121 || this.props.params.m_s_n == 8 || this.props.params.m_s_n == 181) ? 'card-with-additional-des' : ''}>
                                <div className={checkCloseWall == false || this.props.const_var.checkDoorIsadded == true ? 'door-list-wrapper disabled' : 'door-list-wrapper'}>
                                  {/* <ul>
                                    {
                                      (this.props.const_var.newComponentArray['Garage'] != undefined) ?
                                        Object.entries(this.props.const_var.newComponentArray['Garage']).map(([key, value], index) => {
                                          return (
                                            Object.entries(this.props.const_var.newComponentArray['Garage'][key]).map(([key1, value1], index1) => {
                                              // console.log(key, value,key1, value1,"key, value",index,index1)
                                              let newDoorName = ''
                                              if (value1[0].door_add_ons?.[0]?.category[0] != undefined) {
                                                newDoorName = `${value1[0].door_type}_${(value1[0].door_add_ons?.[0]?.category[0].category.split(' ').join('_')).toLowerCase()}`
                                              }
                                              return (
                                                <li onClick={(e) => {
                                                  this.props.addDoorComponent(
                                                    "garage_door",
                                                    key == "overhead_door_door" ? newDoorName : key,
                                                    this.props.params.activeWall,
                                                    value1[0].name,
                                                    "Garage",
                                                    key,
                                                    key1,
                                                    value1[0]
                                                  );
                                                }}>
                                                  <div className='door-window-item relative-container' >
                                                    <div className='door-window-info'>
                                                      <span className='icon icon-walls'></span>
                                                      <span className='text'>{key1}</span>

                                                    </div>
                                                    <div className='door-window-add-cta'>
                                                      <a >
                                                        <span className="icon icon-plus"> </span>
                                                        <span className="text">Add</span>
                                                      </a>
                                                    </div>
                                                    <div>
                                                      {
                                                        nestedComponentCountObj["Garage"].hasOwnProperty(`${value1[0].door_category}`) && <div className='door-count-badge' >{nestedComponentCountObj["Garage"][`${value1[0].door_category}`]} </div>
                                                      }
                                                    </div>
                                                  </div>
                                                </li>
                                              )
                                            })
                                          )
                                        })
                                        : null
                                    }

                                  </ul> */}
                                    
                                  {

                                    (this.props.const_var.newComponentArray['Garage']!=undefined)?
                                    this.props.const_var.newComponentArray['Garage'].map((door, index) => {
                                    
                                        
                                          let newDoorName = ''
                                          let iconName = door.type + '_door';
                                          // if (value1[0].door_add_ons?.[0]?.category[0] != undefined) {
                                          //   newDoorName = `${value1[0].door_type}_${(value1[0].door_add_ons?.[0]?.category[0].category.split(' ').join('_')).toLowerCase()}`
                                          // }

                                          // if (door.type == "panel_garage_door_door") {
                                          //   iconName = "overhead_door_door";
                                          // }
                                          return (
                                            <div className='door-item' onClick={(e) => {
                                              this.props.addDoorComponent(
                                                "garage_door",
                                                (door.type == "overhead_door_door" || door.type =="panel_garage_door_door") ? newDoorName : door.type,
                                                this.props.params.activeWall,
                                                door.sizes[0].fixed_sizes?.[0]?.width + "x" + door.sizes[0].fixed_sizes?.[0]?.height,
                                                "Garage",
                                                door.type,
                                                door.alias_name,
                                                door.sizes[0]
                                              );
                                            }}>
                                            <div>
                                              <div className='door-item-icon'>
                                                <span className={`icon-${iconName}`}>
                                                  {
                                                    newDoorsArray.filter(data => data.parent_array_key == "Garage" && data.nested_array_key == door.type) != undefined &&
                                                    newDoorsArray.filter(data => data.parent_array_key == "Garage" && data.nested_array_key == door.type).length > 0 &&
                                                    <div className='door-count-badge' >
                                                      
                                                      {newDoorsArray.filter(data => data.parent_array_key == "Garage" && data.nested_array_key == door.type).length}
                                                    </div>
                                                  }
                                                </span>
                                              </div>
                                              <div className='door-type'>{door.alias_name}</div>
                                              <div className='door-item-overlay'>CLICK TO ADD</div>
                                              <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                                              {(params.m_s_n == 33 && door.type == "overhead_door_door") ?  <span className="text" style={{fontSize:'9px',fontFamily:'inherit',textAlign:"center"}}>(Available with a Concrete surface)</span>:null}
                                            </div>
                                          </div>
                                          )
    
                                      }
                                    ): null

                                  }
                                 
                                </div>
                                {
                                  (this.props.params.m_s_n == 148 || this.props.params.m_s_n == 121 || this.props.params.m_s_n == 8 || this.props.params.m_s_n == 181) &&
                                  <div className='door-window-additional-text'>Larger door sizes may require additional clearance, lifts, or engineering. Please verify before quoting.</div>
                                }
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>

                          <Card className=''>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="walkindoor" onClick={(e) => this.props.handleAccordion(e)}>
                                <div className='d-flex align-items-center relative-container' >
                                  <span className="icon-walk-in-doors dw-icons"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span class="path4"></span></span>
                                  <span className='text '>Walk-in Door</span>
                                  <div>
                                    {
                                      newDoorsArray.filter(data => data.parent_array_key == "Walk") != undefined &&
                                      newDoorsArray.filter(data => data.parent_array_key == "Walk").length > 0 &&
                                      <div className='door-total-count-badge' >
                                        {newDoorsArray.filter(data => data.parent_array_key == "Walk").length}
                                      </div>
                                    }
                                  </div>
                                </div>

                                <div className=''>
                                  <span className='icon icon-plus'></span>
                                </div>


                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="walkindoor">
                              <Card.Body>
                                <div className={checkCloseWall == false || this.props.const_var.checkDoorIsadded == true ? 'door-list-wrapper disabled' : 'door-list-wrapper'}>
                                  {/* <ul> */}
                                    {
                                      (this.props.const_var.newComponentArray['Walk'] != undefined) ?
                                      <>
                                      {
                                        (params.m_s_n == 148 || params.m_s_n == 121 || params.m_s_n == 8 || params.m_s_n == 181) ? 
                                        this.renderDoorWindowWithSorting(this.props.const_var.newComponentArray['Walk'],newDoorsArray,'walkin')
                                        :
                                        <>
                                        {
                                          this.props.const_var.newComponentArray['Walk'].map((door, index) => {                                                                                         
                                            let doorType = ""
                                           
                                              if(door.type == "4_lite") {
                                                doorType = "four_lite_walkin_door"
                                              } else if(door.type == "5_lite_walkin") {
                                                doorType = "five_lite_walkin"
                                              } else if(door.type == "5_lite_plan_door_walkin") {
                                                doorType = "five_lite_plan_door_walkin"
                                              } else if(door.type == "5_lite_with_right_knob") {
                                                doorType = "five_lite_with_right_knob_walkin"
                                              } else if(door.type == "6_lite_walkin") {
                                                doorType = "six_lite_walkin"
                                              } else if(door.type == "9_lite_walkin" || door.type == "9_lite_l_swing_walkin" || door.type == "9_lite_panel_door_right_knob_walkin") {
                                                doorType = "nine_lite_walkin_door"
                                              } else if(door.type == "11_lite_walkin") {
                                                doorType = "eleven_lite_walkin"
                                              } else if(door.type == "9_lite_double_door_walkin") {
                                                doorType = "nine_lite_double_door_walkin"
                                              } else if(door.type == "11_lite_double_door_walkin") {
                                                doorType = "eleven_lite_double_door_walkin"
                                              } else if(door.type.includes("15_lite_double_door") || door.type == "15_lite_door_with_center_right_knob_walkin") {
                                                doorType = "fifteen_lite_double_door_walkin"
                                              } else if(door.type == "solid_l_swing_walkin") {
                                                doorType = "solid_walkin"
                                              } else if(door.type == "9_lite_plain_door" || door.type == "9_lite_plain_door_right_knob_walkin") {
                                                doorType = "nine_lite_plan_door_walkin"
                                              } else if(door.type.includes("diamond")) {
                                                doorType = "diamond_window_walkin"
                                              } else if(door.type == "black_plain_door_left_knob_walkin" || door.type == "brown_plain_door_left_knob_walkin") {
                                                doorType = "home_door_with_right_knob_walkin"
                                              } else if(door.type == "black_plain_door_right_knob_walkin" ||door.type == "brown_plain_door_right_knob_walkin" ) {
                                                doorType = "standard_walkin"
                                              }else {
                                                doorType = door.type
                                              }
                                            
                                            return (
                                              <div className='door-item' 
                                                onClick={(e) => {
                                                  this.props.addDoorComponent(
                                                    "walkin",
                                                    door.type,
                                                    this.props.params.activeWall,
                                                    door.sizes[0].fixed_sizes?.[0]?.width + "x" + door.sizes[0].fixed_sizes?.[0]?.height,
                                                    "Walk",
                                                    door.type,
                                                    door.alias_name
                                                  );
                                                }}
                                              >
                                                <div>
                                                  <div className='door-item-icon'>
                                                    <span className={`icon-${doorType}`}>
                                                      {
                                                        newDoorsArray.filter(data => data.parent_array_key == "Walk" && data.nested_array_key == door.type) != undefined &&
                                                        newDoorsArray.filter(data => data.parent_array_key == "Walk" && data.nested_array_key == door.type).length > 0 &&
                                                        <div className='door-count-badge' >
                                                          {newDoorsArray.filter(data => data.parent_array_key == "Walk" && data.nested_array_key == door.type).length}
                                                        </div>
                                                      }
                                                    </span>
                                                  </div>
                                                  <div className='door-type'>{door.alias_name}</div>
                                                  <div className='door-item-overlay'>CLICK TO ADD</div>    
                                                  <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span>                                       
                                                </div>
                                              </div>
                                            )                                                                                         
                                          })
                                        }
                                        </>
                                      }
                                      </>
                                        : null
                                    }
                                  {/* </ul> */}
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>

                          <Card className=''>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="window" onClick={(e) => this.props.handleAccordion(e)}>
                                <div className='d-flex align-items-center relative-container' >
                                  <span className='icon-windows dw-icons'></span>
                                  <span className='text '>Windows</span>
                                  <div>
                                    {
                                      newDoorsArray.filter(data => data.parent_array_key == "Windows") != undefined &&
                                      newDoorsArray.filter(data => data.parent_array_key == "Windows").length > 0 &&
                                      <div className='door-total-count-badge' >
                                        {newDoorsArray.filter(data => data.parent_array_key == "Windows").length}
                                      </div>
                                    }
                                  </div>
                                </div>

                                <div className=''>
                                  <span className='icon icon-plus'></span>
                                </div>


                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="window">
                              <Card.Body>
                                <div className={checkCloseWall == false || this.props.const_var.checkDoorIsadded == true ? 'door-list-wrapper disabled' : 'door-list-wrapper'}>
                                  {/* <ul> */}
                                    {
                                      (this.props.const_var.newComponentArray['Windows'] != undefined) ?
                                        <>
                                        {
                                          (params.m_s_n == 148 || params.m_s_n == 121 || params.m_s_n == 8 || params.m_s_n == 181) ? 
                                            this.renderDoorWindowWithSorting(this.props.const_var.newComponentArray['Windows'],newDoorsArray,'window')
                                            :
                                            <>
                                            {
                                              this.props.const_var.newComponentArray['Windows'].map((window, index) => {
                                                                                                  
                                                    let windowType = ""
                                                    if(window.type == "window_with_shutters_window") {
                                                      windowType =  "window_with_shutters_window"
                                                    } else if(window.type == "window_with_shutters_4_grid_window"){
                                                      windowType =  "window_with_shutters_4-grid_window"
                                                    } else if(window.type == "window_with_shutters_6_grid_window") {
                                                      windowType = "window_with_shutters_6-grid_window"
                                                    } else if(window.type == "6_grid_window_with_black_trim_window" || window.type == "black_frame_with_standard_glass_window" || window.type == "window_with_black_grid_window"){
                                                      windowType = "black_frame_with_standard_glass_window"
                                                    } else if(window.type == "black_half_net_window"){
                                                      windowType = "black_half_net_window"
                                                    } else if(window.type == "black_transom_5_grid_window") {
                                                      windowType = "transom_window"
                                                    } else if(window.type.includes("transom_6_grid_window")) {
                                                      windowType = "transom_6_grid_window"
                                                    } else if(window.type == "window_8_grid_window" || window.type == "window_with_white_4_grid_window" || window.type == "window_with_black_4_grid_window" || window.type == "black_window"){
                                                      windowType = "window_eight_grid_window"
                                                    } else if(window.type == "standard_window" || window.type == "window_with_white_6_grid_window"){
                                                      windowType =  "standard_window"
                                                    } else if(window.type.includes("window_without_shutters_window")) {
                                                      windowType = "window_without_shutters_window"
                                                    } else if(window.type.includes("double_pane_single_glass_window")) {
                                                      windowType = "double_pane_window"
                                                    }else if(window.type.includes("black_double_pane_single_glass_window")) {
                                                      windowType = "double_pane_window"
                                                    }else if(window.type.includes("9_panel_(3x3_grid)_window")) {
                                                      windowType = "9_panel_3x3_grid_window"
                                                    }else if(window.type.includes("4_grid_window_with_burnished_slate_trim_window")) {
                                                      windowType = "bronze_window_with_4_grid_window"
                                                    } else {
                                                      windowType = window.type
                                                    }
                                                    return (
                                                      <div className='door-item' onClick={(e) => {
                                                        this.props.addDoorComponent(
                                                          "window",
                                                          window.type,
                                                          this.props.params.activeWall,
                                                          window.sizes[0].fixed_sizes?.[0]?.width + "x" + window.sizes[0].fixed_sizes?.[0]?.height,
                                                          "Windows",
                                                          window.type,
                                                          window.alias_name
                                                        );
                                                      }}>
                                                        {/* <div className='door-window-item relative-container' > */}
                                                          {/* <div className='door-window-info'>
                                                            <span className='icon icon-walls'></span>
                                                            <span className='text'>{key1}</span>
                                                          </div>
                                                          <div className='door-window-add-cta'>
                                                            <a>
                                                              <span className='icon icon-plus'> </span>
                                                              <span className='text'>Add</span>
                                                            </a>
                                                          </div> */}
                                                          <div>
                                                          <div className='door-item-icon'>
                                                          <span className={`icon-${windowType} custom_name`}>
                                                              {
                                                                newDoorsArray.filter(data => data.parent_array_key == "Windows" && data.child_array_key == window.type && data.nested_array_key == window.type) != undefined &&
                                                                newDoorsArray.filter(data => data.parent_array_key == "Windows" && data.child_array_key == window.type && data.nested_array_key == window.type).length > 0 &&
                                                                <div className='door-count-badge' >
                                                                  {newDoorsArray.filter(data => data.parent_array_key == "Windows" && data.child_array_key == window.type && data.nested_array_key == window.type).length}
                                                                </div>
                                                              }
                                                          </span>
                                                          </div>
                                                          <div className='door-type'>{window.alias_name}</div>
                                                          <div className='door-item-overlay'>CLICK TO ADD</div>
                                                          <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                                                        </div>
                                                      </div>
                                                    )                                                                                                  
                                              })
                                            }
                                            </>
                                        }
                                        </>
                                        : null
                                    }
                                  {/* </ul> */}
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>

                          <Card className=''>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="framedopenings" onClick={(e) => this.props.handleAccordion(e)}>
                                <div className='d-flex align-items-center relative-container'>
                                  <span className='icon-custom-framed-openings dw-icons'></span>
                                  <span className='text'>Frame-outs</span>
                                  <div>
                                    {
                                      frameoutCount > 0 && <div className='door-total-count-badge'>{frameoutCount}</div>
                                    }
                                  </div>
                                </div>
                                <div className=''>
                                  <span className='icon icon-plus'></span>
                                </div>
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="framedopenings">
                              <Card.Body>
                                <div className={(isFrameoutDisableWalls == true || this.props.const_var.checkDoorIsadded == true  || (this.props.const_var.wallSelection.centerBuildingWall == "select" && this.props.const_var.wallSelection.leanToWall == "select")) ? 'door-list-wrapper disabled' : 'door-list-wrapper'}>
                                  {/* <ul> */}
                                    {(this.props.const_var.newComponentArray['Garage_Frameout'] != undefined) ?
                                      Object.entries(this.props.const_var.newComponentArray['Garage_Frameout']).map(([key, value], index) => {
                                        return (
                                          Object.entries(this.props.const_var.newComponentArray['Garage_Frameout'][key]).map(([key1, value1], index1) => {
                                            let manufacturerDoorName = this.props.params.doorNames[this.props.params.m_s_n] || key1;
                                            return (
                                              <div className='door-item' onClick={(e) => {
                                                this.props.addDoorComponent(
                                                  "garage_door_frameout",
                                                  key,
                                                  this.props.params.activeWall,
                                                  this.props.const_var.customFrameoutInitialSize,
                                                  "Garage_Frameout",
                                                  key,
                                                  key1
                                                );
                                              }}
                                              >
                                                {/* <div className='door-window-item'>
                                                  <div className='door-window-info'>
                                                    <span className='icon icon-walls'></span>
                                                    <span className='text'>{key1} Frameout</span>
                                                  </div> */}
                                                  {/* <div className='door-window-add-cta'>
                                                    <a>
                                                      <span className="icon icon-plus"></span>
                                                      <span className="text">Add</span>
                                                    </a>
                                                  </div> */}

                                                  <div>
                                                    <div className='door-item-icon'>
                                                    <span className={`icon-garage-in-door-frame-out`}>
                                                      {
                                                        newDoorsArray.filter(data=>data.parent_array_key=="Garage_Frameout" && data.nested_array_key == key1) != undefined && 
                                                        newDoorsArray.filter(data=>data.parent_array_key=="Garage_Frameout" && data.nested_array_key == key1).length > 0 &&  
                                                        <div className='door-count-badge' >
                                                          {newDoorsArray.filter(data=>data.parent_array_key=="Garage_Frameout" && data.nested_array_key == key1).length} 
                                                        </div>
                                                      }
                                                    </span>
                                                    </div>
                                                    {
                                                      (params.m_s_n == 148 || params.m_s_n == 121 || params.m_s_n == 8 || params.m_s_n == 181) && manufacturerDoorName == "Roll-Up" ?
                                                      <div className='door-type'>Frameout</div>
                                                      :
                                                      <div className='door-type'>{`${manufacturerDoorName} ${(manufacturerDoorName.includes("Frame")) ? "" : "Frameout"}`}</div>
                                                    }
                                                    <div className='door-item-overlay'>CLICK TO ADD</div>
                                                    <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                                         
                                                {/* </div> */}
                                                  </div>
                                                </div>
                                              
                                            )
                                          })
                                        )
                                      })
                                      : null
                                    }
                                    {(this.props.const_var.newComponentArray['Walk_Frameout'] != undefined) ?
                                      Object.entries(this.props.const_var.newComponentArray['Walk_Frameout']).map(([key, value], index) => {
                                        if (key == "standard_walkin") {
                                          return (
                                            Object.entries(this.props.const_var.newComponentArray['Walk_Frameout'][key]).map(([key1, value1], index1) => {
                                              return (
                                                <div className='door-item' onClick={(e) => {
                                                  this.props.addDoorComponent(
                                                    "walkin_frameout",
                                                    key,
                                                    this.props.params.activeWall,
                                                    value1[0].name,
                                                    "Walk_Frameout",
                                                    key,
                                                    key1
                                                  );
                                                }}>
                                                  {/* <div className='door-window-item'>
                                                    <div className='door-window-info'>
                                                      <span className='icon icon-walls'></span>
                                                      <span className='text'>{key1} Frameout</span>
                                                    </div>
                                                    <div className='door-window-add-cta'>
                                                      <a>
                                                        <span className='icon icon-plus'> </span>
                                                        <span className='text'>Add</span>
                                                      </a>
                                                    </div> */}
                                                  <div>
                                                    <div className='door-item-icon'>
                                                    <span className={`icon-walk-in-door-frame-out`}>
                                                      {
                                                        newDoorsArray.filter(data=>data.parent_array_key=="Walk_Frameout" && data.nested_array_key == key1) != undefined && 
                                                        newDoorsArray.filter(data=>data.parent_array_key=="Walk_Frameout" && data.nested_array_key == key1).length > 0 &&  
                                                        <div className='door-count-badge' >
                                                          {newDoorsArray.filter(data=>data.parent_array_key=="Walk_Frameout" && data.nested_array_key == key1).length} 
                                                        </div>
                                                      }
                                                    </span>
                                                    </div>
                                                   <div className='door-type'>{key1} Frameout</div>
                                                    <div className='door-item-overlay'>CLICK TO ADD</div>
                                                    <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                                         

                                                  </div>
                                                </div>
                                              )
                                            })
                                          )
                                        }
                                      })
                                      : null
                                    }
                                    {(this.props.const_var.newComponentArray['Windows_Frameout'] != undefined) ?
                                      Object.entries(this.props.const_var.newComponentArray['Windows_Frameout']).map(([key, value], index) => {
                                        if (key == "standard_window") {
                                          return (
                                            Object.entries(this.props.const_var.newComponentArray['Windows_Frameout'][key]).map(([key1, value1], index1) => {
                                              return (
                                                <div className='door-item' onClick={(e) => {
                                                  this.props.addDoorComponent(
                                                    "window_frameout",
                                                    key,
                                                    this.props.params.activeWall,
                                                    value1[0].name,
                                                    "Windows_Frameout",
                                                    key,
                                                    key1
                                                  );
                                                }}>
                                                  {/* <div className='door-window-item'>
                                                    <div className='door-window-info'>
                                                      <span className='icon icon-walls'></span>
                                                      <span className='text'>{key1} Frameout</span>
                                                    </div>
                                                    <div className='door-window-add-cta'>
                                                      <a>
                                                        <span className='icon icon-plus'> </span>
                                                        <span className='text'>Add</span>
                                                      </a>
                                                    </div>
                                                  </div> */}
                                                    <div>
                                                    <div className='door-item-icon'>
                                                    <span className={`icon-window-frame-out`}>
                                                      {
                                                        newDoorsArray.filter(data=>data.parent_array_key=="Windows_Frameout" && data.nested_array_key == key1) != undefined && 
                                                        newDoorsArray.filter(data=>data.parent_array_key=="Windows_Frameout" && data.nested_array_key == key1).length > 0 &&  
                                                        <div className='door-count-badge' >
                                                          {newDoorsArray.filter(data=>data.parent_array_key=="Windows_Frameout" && data.nested_array_key == key1).length} 
                                                        </div>
                                                      }
                                                    </span>
                                                    </div>
                                                      <div className='door-type'>Window Frameout</div> 
                                                    <div className='door-item-overlay'>CLICK TO ADD</div>
                                                    <span className={this.props.const_var.checkDoorIsadded?"active saving-effect saving-effect-type-2":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span> 
                                         
                                                </div>
                                                </div>
                                              )
                                            })
                                          )
                                        }
                                      })
                                      : null
                                    }
                                  {/* </ul> */}
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </div>
                    </div>
                  </aside>
                </div>
              </div>
            </form>
            <div className='read-box d-none'>
              <ReadMore>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</ReadMore>
            </div>
            <Scrollbar className={(this.props.params.add_left_lean == true || this.props.params.add_right_lean == true) ? "vr-scroll-1 d-none" : " vr-scroll-1 without-tab  d-none"} noScrollX >
              <div className="price-row mb-3">
                <aside className="price-row-left">
                  <div className="col-12">
                    <p class="text-panelprimary f-12 barlow-semibold mb-0">Edit the Building Height to put a larger size garage door.</p>
                  </div>
                </aside>
              </div>
              <div className="price-row mb-3">
                <aside className="price-row-left with-inner-edit">
                  <div className="col-12">

                    <div className="floating-label-input floating-label-inside border-0 with-seprator">
                      <Select
                        onChange={e => { this.props.changeBuildingDimension(e.target.value, 'h'); }}
                        value={this.props.params.p_h}
                        className="cpanelselect"
                        label="Height"
                        ripple="RipplePropF"
                        options={this.props.const_var.buildingHeightArray}
                      />

                      {(this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession != true) && this.props.const_var.post_data.building !== undefined && this.props.const_var.post_data.building.height_price !== 0 &&
                        <div className="with-seprator-box">
                          <div className="price-box-type-2">
                            <CurrencyFormat value={this.props.const_var.post_data.building.height_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </aside>

                {(this.props.const_var.loginSession == true) ?
                  <aside className="price-box position-sticky">
                    {((this.props.const_var.post_data.building !== undefined)) ?
                      <EditPriceItem jsonObj={this.props.const_var.post_data.building.height_price} jsonObjKey="height_price" />
                      : null
                    }
                  </aside>
                  : null
                }
              </div>
            </Scrollbar>
          </div>
        </div>
      </div>


    );
  }
}
const mapStoreToProps = (state) => {
  return {...state.reducer, ...state.reducer.const_var}
}


export default connect(
  mapStoreToProps,
  actionCreator
)(DoorWindow);